import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';

import { Col } from 'reactstrap';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getProcessList } from '../api';
import { ProcessListResponse } from '../types';

export interface ProcessListLoaderProps {
  children: ReactElement;
  academicOfferId: number;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  ProcessListResponse,
  AxiosResultDefaultError
>();

export const useProcessList = useFetch;

export const ProcessListLoaderConsumer = FetchConsumer;

export function ProcessListLoader({
  children,
  academicOfferId,
}: ProcessListLoaderProps) {
  const request = useCallback(async () => {
    return getProcessList(academicOfferId);
  }, [academicOfferId]);

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <Col md={12}>
                <DisplayError
                  insideCard
                  textBody={error.code}
                  retryAction={refresh}
                  loadingAction={loading}
                />
              </Col>
            );
          }
          if (loading) {
            return (
              <Col md={12}>
                <Loading insideCard />
              </Col>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
